var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDashboardMyCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96.977,
    height: 100,
    viewBox: "0 0 96.977 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.81 49.069H48.488l-1.953 29.8L48.488 100c15.885 0 28.761-12.877 28.761-28.76 0-8.923-4.063-16.896-10.44-22.171z",
    fill: "#7A7DC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.167 49.069c-6.376 5.275-10.44 13.248-10.44 22.17C19.728 87.123 32.605 100 48.489 100V49.069h-18.32z",
    fill: "#BAB1DF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84D15E",
    d: "m48.488 0-1.953 9.766 1.953 9.293h14.399l-14.399 23.42-1.953 11.983 1.953 24.407L96.977 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7E888",
    d: "M34.09 19.059h14.398V0H0l48.488 78.87V42.478z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboardMyCalender);
export default __webpack_public_path__ + "static/media/ic_dashboard_my_calender.990d5ed11e0f9afd674c90861fc9f7aa.svg";
export { ForwardRef as ReactComponent };